let env = null;

import prod from './prod'
import dev from './dev'

if (process.env.NODE_ENV === 'development') {
  env = dev;
} else if (process.env.NODE_ENV === 'production') {
  env = prod;
}

export default env




// WEBPACK FOOTER //
// ./src/config/loadEnv.js